import { render, staticRenderFns } from "./newProductDetails.vue?vue&type=template&id=02a76e31&scoped=true&"
import script from "./newProductDetails.vue?vue&type=script&lang=js&"
export * from "./newProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./newProductDetails.vue?vue&type=style&index=0&id=02a76e31&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a76e31",
  null
  
)

export default component.exports